import styles from "./CommonFields.module.css";
import { RangeSlider, Select } from "@shopify/polaris";
import CustomInputWithUnit from "../../../components/CustomInputWithUnit/CustomInputWithUnit";
import { BundleTypes, FontStyles } from "../constants";
import { Field } from "@shopify/react-form";
import NewCustomColorPicker from "../../../components/NewCustomColorPicker/NewCustomColorPicker";

import FormSubSection from "./FormSubSection";
import FontsSelect from "../../../components/FontsSelect";
import { FONTS } from "../../../utilities/fonts";
interface Props_ProductCard {
    dispatchBundleConfig: (action: any) => void;
    cardName?: string | null;
    bundleType: any;
    // Optional fields
    bundle_widget_bg?: Field<string> | null;
    bundle_title_color?: Field<string> | null;
    bundle_title_size?: Field<number> | null;
    bundle_title_style?: Field<string> | null;
    bundle_widget_font_family?: Field<string> | null;
    show_line_around_title_color?: Field<string>;
    timer_color?: Field<string>;
    timer_text_color?: Field<string>;
    timer_background_color?: Field<string>;
    timer_font_style?: Field<string> | null;
    timer_font_size?: Field<number> | null;
    special_text_background_color?: Field<string>;
    special_text_color?: Field<string>;
    special_text_font_size?: Field<number> | null;
    special_text_style?: Field<string> | null;
    discount_label_font_size?: Field<number> | null;
    discount_label_style?: Field<string> | null;
    progress_bar_color?: Field<string> | null;
    progress_bar_bg_color?: Field<string> | null;
    show_progress_bar?: boolean;
    discount_tabs_quantity_label_size?: Field<number> | null;
    discount_tabs_quantity_label_style?: Field<string> | null;
    discount_tabs_discount_label_size?: Field<number> | null;
    discount_label_background_color?: Field<string>;
    discount_label_color?: Field<string>;
    discount_tabs_quantity_label_color?: Field<string>;
    discount_tabs_discount_label_color?: Field<string>;
    discount_tabs_bg_color?: Field<string>;
    discount_tabs_selected_bg_color?: Field<string>;
    discount_tabs_selected_text_color?: Field<string>;
    discount_tabs_border_width?: Field<number>;
    discount_tabs_border_color?: Field<string>;
    discount_tabs_selected_border_color?: Field<string>;
    section_tabs_title_size?: Field<number> | null;
    section_tabs_subtitle_size?: Field<number> | null;
    section_tabs_title_style?: Field<string> | null;
    section_tabs_title_color?: Field<string>;
    section_tabs_unselected_bg_color?: Field<string>;
    section_tabs_unselected_title_color?: Field<string>;
    section_tabs_bg_color?: Field<string>;
    section_tabs_subtitle_color?: Field<string>;
    discount_tabs_border_radius?: Field<number> | null;
    section_tabs_border_radius?: Field<number> | null;
    popup_heading_color?: Field<string> | null;
    popup_heading_bg_color?: Field<string> | null;
    popup_heading_size?: Field<number> | null;
    popup_heading_style?: Field<string> | null;
    dotted_border_color?: Field<string> | null;
    step_container_bg?: Field<string> | null;
    product_background_color?: Field<string> | null;
    bundle_border_width?: Field<number> | null;
    bundle_border_color?: Field<string> | null;
    product_card_seperator_width: Field<number> | null;
    product_card_seperator_color: Field<string> | null;
}

const DesignGeneralCard = ({
    dispatchBundleConfig,
    bundleType,
    bundle_widget_bg,
    bundle_title_color,
    bundle_widget_font_family,
    bundle_title_style,
    bundle_title_size,
    show_line_around_title_color,
    special_text_background_color,
    special_text_color,
    special_text_font_size,
    special_text_style,
    timer_color,
    timer_text_color,
    timer_background_color,
    timer_font_style,
    timer_font_size,
    progress_bar_color,
    progress_bar_bg_color,
    show_progress_bar,
    discount_tabs_quantity_label_size,
    discount_tabs_quantity_label_style,
    discount_tabs_discount_label_size,
    discount_label_background_color,
    discount_label_color,
    discount_tabs_quantity_label_color,
    discount_tabs_discount_label_color,
    discount_tabs_bg_color,
    discount_tabs_selected_bg_color,
    discount_tabs_selected_text_color,
    discount_tabs_border_width,
    discount_tabs_border_color,
    discount_tabs_selected_border_color,
    discount_label_font_size,
    discount_label_style,
    section_tabs_title_size,
    section_tabs_subtitle_size,
    section_tabs_title_style,
    section_tabs_title_color,
    section_tabs_unselected_bg_color,
    section_tabs_unselected_title_color,
    section_tabs_bg_color,
    section_tabs_subtitle_color,
    discount_tabs_border_radius,
    section_tabs_border_radius,
    popup_heading_color,
    popup_heading_bg_color,
    popup_heading_size,
    popup_heading_style,
    dotted_border_color,
    step_container_bg,
    product_background_color,
    bundle_border_width,
    bundle_border_color,
    product_card_seperator_color,
    product_card_seperator_width,
}: Props_ProductCard) => {
    return (
        <div>
            {(bundle_widget_bg || bundle_widget_font_family) && (
                <div id="general-design">
                    <FormSubSection rowLabel={"General"}>
                        {bundle_widget_bg && (
                            <NewCustomColorPicker
                                hexColor={bundle_widget_bg.value}
                                setHexColor={(val) => {
                                    bundle_widget_bg.onChange(val);

                                    dispatchBundleConfig({
                                        payload: {
                                            [bundleType === BundleTypes.STANDARD
                                                ? "product_background_color"
                                                : "bundle_widget_bg"]: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Bundle Widget Background"}
                                props={{ ...bundle_widget_bg, onBlur: () => bundle_widget_bg?.runValidation() }}
                            />
                        )}

                        {bundle_widget_font_family && (
                            <FontsSelect
                                label={"Font Family"}
                                options={FONTS}
                                placeholder="Font style"
                                onChange={(val) => {
                                    bundle_widget_font_family.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            bundle_widget_font_family: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={bundle_widget_font_family.value}
                            />
                        )}

                        {step_container_bg && (
                            <NewCustomColorPicker
                                hexColor={step_container_bg.value}
                                setHexColor={(val) => {
                                    step_container_bg.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            step_container_bg: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Step Container Background"}
                                props={{ ...step_container_bg, onBlur: () => step_container_bg?.runValidation() }}
                            />
                        )}

                        {dotted_border_color && (
                            <NewCustomColorPicker
                                hexColor={dotted_border_color.value}
                                setHexColor={(val) => {
                                    dotted_border_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            dotted_border_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Add Product Border Color"}
                                props={{ ...dotted_border_color, onBlur: () => dotted_border_color?.runValidation() }}
                            />
                        )}

                        {bundle_border_width && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Bundle Border Width"}
                                placeholder={"border width"}
                                setValue={(val) => {
                                    bundle_border_width.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            bundle_border_width: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={bundle_border_width.value}
                                unitSuffix={"px"}
                                props={{ ...bundle_border_width, onBlur: () => bundle_border_width.runValidation() }}
                            />
                        )}
                        {bundle_border_color && (
                            <NewCustomColorPicker
                                hexColor={bundle_border_color.value}
                                setHexColor={(val) => {
                                    bundle_border_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            bundle_border_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Bundle Border Color"}
                                props={{ ...bundle_border_color, onBlur: () => bundle_border_color?.runValidation() }}
                            />
                        )}

                        {product_card_seperator_width && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Seperator Width"}
                                placeholder={"Seperator width"}
                                setValue={(val) => {
                                    product_card_seperator_width.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_card_seperator_width: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={product_card_seperator_width.value}
                                unitSuffix={"px"}
                                props={{
                                    ...product_card_seperator_width,
                                    onBlur: () => product_card_seperator_width.runValidation(),
                                }}
                            />
                        )}
                        {product_card_seperator_color && (
                            <NewCustomColorPicker
                                hexColor={product_card_seperator_color.value}
                                setHexColor={(val) => {
                                    product_card_seperator_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_card_seperator_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Seperator Color"}
                                props={{
                                    ...product_card_seperator_color,
                                    onBlur: () => product_card_seperator_color?.runValidation(),
                                }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(bundle_title_color || bundle_title_size || bundle_title_style || show_line_around_title_color) && (
                <div id="bundle-title-design">
                    <FormSubSection
                        rowLabel={"Bundle Title"}
                        hideSeparator={[
                            BundleTypes.STANDARD,
                            BundleTypes.PRODUCT_ADDONS,
                            BundleTypes.FBT,
                            BundleTypes.BB_PLACEHOLDER,
                        ]?.includes(bundleType)}
                    >
                        {bundle_title_color && (
                            <NewCustomColorPicker
                                hexColor={bundle_title_color.value}
                                setHexColor={(val) => {
                                    bundle_title_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            bundle_title_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...bundle_title_color, onBlur: () => bundle_title_color?.runValidation() }}
                            />
                        )}

                        {bundle_title_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    bundle_title_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            bundle_title_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={bundle_title_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...bundle_title_size,
                                    onBlur: () => bundle_title_size?.runValidation(),
                                }}
                            />
                        )}
                        {bundle_title_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    bundle_title_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            bundle_title_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={bundle_title_style.value}
                            />
                        )}
                        {show_line_around_title_color && (
                            <NewCustomColorPicker
                                hexColor={show_line_around_title_color.value}
                                setHexColor={(val) => {
                                    show_line_around_title_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            show_line_around_title_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Lines Around Title"}
                                props={{
                                    ...show_line_around_title_color,
                                    onBlur: () => show_line_around_title_color?.runValidation(),
                                }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(special_text_background_color || special_text_color || special_text_font_size || special_text_style) && (
                <div id="special-text-design">
                    <FormSubSection
                        rowLabel={"Special Text"}
                        hideSeparator={[BundleTypes.BXGY, BundleTypes.BB_PLACEHOLDER]?.includes(bundleType)}
                    >
                        {special_text_background_color && (
                            <NewCustomColorPicker
                                hexColor={special_text_background_color.value}
                                setHexColor={(val) => {
                                    special_text_background_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            special_text_background_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...special_text_background_color,
                                    onBlur: () => special_text_background_color?.runValidation(),
                                }}
                            />
                        )}

                        {special_text_color && (
                            <NewCustomColorPicker
                                hexColor={special_text_color.value}
                                setHexColor={(val) => {
                                    special_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            special_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...special_text_color, onBlur: () => special_text_color?.runValidation() }}
                            />
                        )}

                        {special_text_font_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    special_text_font_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            special_text_font_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={special_text_font_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...special_text_font_size,
                                    onBlur: () => special_text_font_size?.runValidation(),
                                }}
                            />
                        )}
                        {special_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    special_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            special_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={special_text_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(timer_background_color || timer_text_color || timer_color || timer_font_size || timer_font_style) && (
                <div id="countdown-timer-design">
                    <FormSubSection rowLabel={"Timer"}>
                        {timer_background_color && (
                            <NewCustomColorPicker
                                hexColor={timer_background_color.value}
                                setHexColor={(val) => {
                                    timer_background_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            timer_background_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...timer_background_color,
                                    onBlur: () => timer_background_color?.runValidation(),
                                }}
                            />
                        )}
                        {timer_text_color && (
                            <NewCustomColorPicker
                                hexColor={timer_text_color.value}
                                setHexColor={(val) => {
                                    timer_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            timer_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...timer_text_color, onBlur: () => timer_text_color?.runValidation() }}
                            />
                        )}
                        {timer_color && (
                            <NewCustomColorPicker
                                hexColor={timer_color.value}
                                setHexColor={(val) => {
                                    timer_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            timer_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Timer Color"}
                                props={{ ...timer_color, onBlur: () => timer_color?.runValidation() }}
                            />
                        )}

                        {timer_font_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    timer_font_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            timer_font_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={timer_font_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...timer_font_size,
                                    onBlur: () => timer_font_size?.runValidation(),
                                }}
                            />
                        )}
                        {timer_font_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    timer_font_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            timer_font_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={timer_font_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(discount_label_background_color ||
                discount_label_color ||
                discount_label_font_size ||
                discount_label_style ||
                discount_tabs_bg_color ||
                discount_tabs_discount_label_color ||
                discount_tabs_quantity_label_color ||
                discount_tabs_quantity_label_size ||
                discount_tabs_quantity_label_style ||
                discount_tabs_discount_label_size ||
                discount_tabs_border_radius ||
                progress_bar_color ||
                progress_bar_bg_color ||
                discount_tabs_selected_bg_color ||
                discount_tabs_selected_text_color ||
                discount_tabs_border_width ||
                discount_tabs_border_color ||
                discount_tabs_selected_border_color) && (
                <div id="discount-label-design">
                    <FormSubSection
                        rowLabel={
                            [BundleTypes.MIX_MATCH_SECTIONAL, BundleTypes.MIX_MATCH]?.includes(bundleType)
                                ? "Discount Tab"
                                : "Discount Label"
                        }
                        hideSeparator={[BundleTypes.VOLUME_DISCOUNT, BundleTypes?.MIX_MATCH]?.includes(bundleType)}
                    >
                        {discount_label_background_color && (
                            <NewCustomColorPicker
                                hexColor={discount_label_background_color.value}
                                setHexColor={(val) => {
                                    discount_label_background_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_label_background_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...discount_label_background_color,
                                    onBlur: () => discount_label_background_color?.runValidation(),
                                }}
                            />
                        )}
                        {discount_label_color && (
                            <NewCustomColorPicker
                                hexColor={discount_label_color.value}
                                setHexColor={(val) => {
                                    discount_label_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_label_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...discount_label_color, onBlur: () => discount_label_color?.runValidation() }}
                            />
                        )}

                        {discount_label_font_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    discount_label_font_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_label_font_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={discount_label_font_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...discount_label_font_size,
                                    onBlur: () => discount_label_font_size?.runValidation(),
                                }}
                            />
                        )}
                        {discount_label_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    discount_label_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_label_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={discount_label_style.value}
                            />
                        )}
                        {[BundleTypes.MIX_MATCH, BundleTypes.MIX_MATCH_SECTIONAL].includes(bundleType) &&
                        show_progress_bar ? (
                            <>
                                {progress_bar_color && (
                                    <NewCustomColorPicker
                                        hexColor={progress_bar_color.value}
                                        setHexColor={(val) => {
                                            progress_bar_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    progress_bar_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Progress Bar Foreground"}
                                        props={{
                                            ...progress_bar_color,
                                            onBlur: () => progress_bar_color?.runValidation(),
                                        }}
                                    />
                                )}
                                {progress_bar_bg_color && (
                                    <NewCustomColorPicker
                                        hexColor={progress_bar_bg_color.value}
                                        setHexColor={(val) => {
                                            progress_bar_bg_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    progress_bar_bg_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Progress Bar Background"}
                                        props={{
                                            ...progress_bar_bg_color,
                                            onBlur: () => progress_bar_bg_color?.runValidation(),
                                        }}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {discount_tabs_bg_color && (
                                    <NewCustomColorPicker
                                        hexColor={discount_tabs_bg_color.value}
                                        setHexColor={(val) => {
                                            discount_tabs_bg_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    discount_tabs_bg_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Background Color"}
                                        props={{
                                            ...discount_tabs_bg_color,
                                            onBlur: () => discount_tabs_bg_color?.runValidation(),
                                        }}
                                    />
                                )}
                            </>
                        )}

                        {discount_tabs_discount_label_color && (
                            <NewCustomColorPicker
                                hexColor={discount_tabs_discount_label_color.value}
                                setHexColor={(val) => {
                                    discount_tabs_discount_label_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_tabs_discount_label_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...discount_tabs_discount_label_color,
                                    onBlur: () => discount_tabs_discount_label_color?.runValidation(),
                                }}
                            />
                        )}

                        {discount_tabs_selected_bg_color && (
                            <NewCustomColorPicker
                                hexColor={discount_tabs_selected_bg_color.value}
                                setHexColor={(val) => {
                                    discount_tabs_selected_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_tabs_selected_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Active Background Color"}
                                props={{
                                    ...discount_tabs_selected_bg_color,
                                    onBlur: () => discount_tabs_selected_bg_color?.runValidation(),
                                }}
                            />
                        )}

                        {discount_tabs_selected_text_color && (
                            <NewCustomColorPicker
                                hexColor={discount_tabs_selected_text_color.value}
                                setHexColor={(val) => {
                                    discount_tabs_selected_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_tabs_selected_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Active Text Color"}
                                props={{
                                    ...discount_tabs_selected_text_color,
                                    onBlur: () => discount_tabs_selected_text_color?.runValidation(),
                                }}
                            />
                        )}

                        {discount_tabs_quantity_label_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Text Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    discount_tabs_quantity_label_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_tabs_quantity_label_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={discount_tabs_quantity_label_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...discount_tabs_quantity_label_size,
                                    onBlur: () => discount_tabs_quantity_label_size?.runValidation(),
                                }}
                            />
                        )}
                        {discount_tabs_quantity_label_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    discount_tabs_quantity_label_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_tabs_quantity_label_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={discount_tabs_quantity_label_style.value}
                            />
                        )}

                        {!(
                            [BundleTypes.MIX_MATCH, BundleTypes.MIX_MATCH_SECTIONAL].includes(bundleType) &&
                            !show_progress_bar
                        ) &&
                            discount_tabs_quantity_label_color && (
                                <NewCustomColorPicker
                                    hexColor={discount_tabs_quantity_label_color.value}
                                    setHexColor={(val) => {
                                        discount_tabs_quantity_label_color.onChange(val);
                                        dispatchBundleConfig({
                                            payload: {
                                                discount_tabs_quantity_label_color: val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    label={
                                        [BundleTypes.MIX_MATCH, BundleTypes.MIX_MATCH_SECTIONAL].includes(bundleType)
                                            ? "Subtext Color"
                                            : "Discount Tab Quantity Label"
                                    }
                                    props={{
                                        ...discount_tabs_quantity_label_color,
                                        onBlur: () => discount_tabs_quantity_label_color?.runValidation(),
                                    }}
                                />
                            )}
                        {discount_tabs_discount_label_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Subtext Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    discount_tabs_discount_label_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            discount_tabs_discount_label_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={discount_tabs_discount_label_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...discount_tabs_discount_label_size,
                                    onBlur: () => discount_tabs_discount_label_size?.runValidation(),
                                }}
                            />
                        )}
                        {!(
                            [BundleTypes.MIX_MATCH, BundleTypes.MIX_MATCH_SECTIONAL].includes(bundleType) &&
                            show_progress_bar
                        ) && (
                            <>
                                {discount_tabs_border_color && (
                                    <NewCustomColorPicker
                                        hexColor={discount_tabs_border_color.value}
                                        setHexColor={(val) => {
                                            discount_tabs_border_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    discount_tabs_border_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Border Color"}
                                        props={{
                                            ...discount_tabs_border_color,
                                            onBlur: () => discount_tabs_border_color?.runValidation(),
                                        }}
                                    />
                                )}

                                {discount_tabs_selected_border_color && (
                                    <NewCustomColorPicker
                                        hexColor={discount_tabs_selected_border_color.value}
                                        setHexColor={(val) => {
                                            discount_tabs_selected_border_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    discount_tabs_selected_border_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Selected Border Color"}
                                        props={{
                                            ...discount_tabs_selected_border_color,
                                            onBlur: () => discount_tabs_selected_border_color?.runValidation(),
                                        }}
                                    />
                                )}

                                {discount_tabs_border_width && (
                                    <CustomInputWithUnit
                                        min={0}
                                        label={"Border Width"}
                                        placeholder={"Border Width"}
                                        setValue={(val) => {
                                            discount_tabs_border_width.onChange(+val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    discount_tabs_border_width: +val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        value={discount_tabs_border_width.value}
                                        unitSuffix={"px"}
                                        props={{
                                            ...discount_tabs_border_width,
                                            onBlur: () => discount_tabs_border_width?.runValidation(),
                                        }}
                                    />
                                )}

                                {discount_tabs_border_radius && (
                                    <span className={styles.rangeSliderOverride}>
                                        <RangeSlider
                                            min={0}
                                            max={100}
                                            label={"Border Radius"}
                                            value={discount_tabs_border_radius.value}
                                            onChange={(val) => {
                                                discount_tabs_border_radius.onChange(+val);
                                                dispatchBundleConfig({
                                                    payload: {
                                                        discount_tabs_border_radius: +val,
                                                    },
                                                    isComplex: true,
                                                    key: "bundles_design",
                                                });
                                            }}
                                            output
                                            suffix={(discount_tabs_border_radius.value || 0) + "px"}
                                            error={discount_tabs_border_radius.error}
                                            onBlur={() => discount_tabs_border_radius?.runValidation()}
                                        />
                                    </span>
                                )}
                            </>
                        )}
                    </FormSubSection>
                </div>
            )}
            {(section_tabs_bg_color ||
                section_tabs_title_color ||
                section_tabs_subtitle_color ||
                section_tabs_title_size ||
                section_tabs_title_style ||
                section_tabs_subtitle_size ||
                section_tabs_border_radius ||
                section_tabs_unselected_bg_color ||
                section_tabs_unselected_title_color) && (
                <div id="section-tabs-design">
                    <FormSubSection
                        rowLabel={"Section Tab"}
                        hideSeparator={BundleTypes.MIX_MATCH_SECTIONAL == bundleType}
                    >
                        {section_tabs_bg_color && (
                            <NewCustomColorPicker
                                hexColor={section_tabs_bg_color.value}
                                setHexColor={(val) => {
                                    section_tabs_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            section_tabs_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Selected BG Color"}
                                props={{
                                    ...section_tabs_bg_color,
                                    onBlur: () => section_tabs_bg_color?.runValidation(),
                                }}
                            />
                        )}

                        {section_tabs_title_color && (
                            <NewCustomColorPicker
                                hexColor={section_tabs_title_color.value}
                                setHexColor={(val) => {
                                    section_tabs_title_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            section_tabs_title_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Selected Text Color"}
                                props={{
                                    ...section_tabs_title_color,
                                    onBlur: () => section_tabs_title_color?.runValidation(),
                                }}
                            />
                        )}

                        {section_tabs_unselected_bg_color && (
                            <NewCustomColorPicker
                                hexColor={section_tabs_unselected_bg_color.value}
                                setHexColor={(val) => {
                                    section_tabs_unselected_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            section_tabs_unselected_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Unselected BG Color"}
                                props={{
                                    ...section_tabs_unselected_bg_color,
                                    onBlur: () => section_tabs_unselected_bg_color?.runValidation(),
                                }}
                            />
                        )}

                        {section_tabs_unselected_title_color && (
                            <NewCustomColorPicker
                                hexColor={section_tabs_unselected_title_color.value}
                                setHexColor={(val) => {
                                    section_tabs_unselected_title_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            section_tabs_unselected_title_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Unselected Text Color"}
                                props={{
                                    ...section_tabs_unselected_title_color,
                                    onBlur: () => section_tabs_unselected_title_color?.runValidation(),
                                }}
                            />
                        )}

                        {section_tabs_subtitle_color && (
                            <NewCustomColorPicker
                                hexColor={section_tabs_subtitle_color.value}
                                setHexColor={(val) => {
                                    section_tabs_subtitle_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            section_tabs_subtitle_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Description Text Color"}
                                props={{
                                    ...section_tabs_subtitle_color,
                                    onBlur: () => section_tabs_subtitle_color?.runValidation(),
                                }}
                            />
                        )}
                        {section_tabs_title_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Text Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    section_tabs_title_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            section_tabs_title_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={section_tabs_title_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...section_tabs_title_size,
                                    onBlur: () => section_tabs_title_size?.runValidation(),
                                }}
                            />
                        )}
                        {section_tabs_title_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    section_tabs_title_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            section_tabs_title_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={section_tabs_title_style.value}
                            />
                        )}

                        {section_tabs_subtitle_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Description Text Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    section_tabs_subtitle_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            section_tabs_subtitle_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={section_tabs_subtitle_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...section_tabs_subtitle_size,
                                    onBlur: () => section_tabs_subtitle_size?.runValidation(),
                                }}
                            />
                        )}

                        {section_tabs_border_radius && (
                            <span className={styles.rangeSliderOverride}>
                                <RangeSlider
                                    min={0}
                                    max={100}
                                    label={"Border Radius"}
                                    value={section_tabs_border_radius.value}
                                    onChange={(val) => {
                                        section_tabs_border_radius.onChange(+val);
                                        dispatchBundleConfig({
                                            payload: {
                                                section_tabs_border_radius: +val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    output
                                    suffix={(section_tabs_border_radius.value || 0) + "px"}
                                    error={section_tabs_border_radius.error}
                                    onBlur={() => section_tabs_border_radius?.runValidation()}
                                />
                            </span>
                        )}
                    </FormSubSection>
                </div>
            )}

            {(popup_heading_bg_color || popup_heading_color || popup_heading_size || popup_heading_style) && (
                <div id="popup-design">
                    <FormSubSection rowLabel={"Popup"} hideSeparator={true}>
                        {popup_heading_bg_color && (
                            <NewCustomColorPicker
                                hexColor={popup_heading_bg_color.value}
                                setHexColor={(val) => {
                                    popup_heading_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            popup_heading_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Header Background Color"}
                                props={{
                                    ...popup_heading_bg_color,
                                    onBlur: () => popup_heading_bg_color?.runValidation(),
                                }}
                            />
                        )}
                        {popup_heading_color && (
                            <NewCustomColorPicker
                                hexColor={popup_heading_color.value}
                                setHexColor={(val) => {
                                    popup_heading_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            popup_heading_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Heading Text Color"}
                                props={{ ...popup_heading_color, onBlur: () => popup_heading_color?.runValidation() }}
                            />
                        )}

                        {popup_heading_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    popup_heading_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            popup_heading_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={popup_heading_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...popup_heading_size,
                                    onBlur: () => popup_heading_size?.runValidation(),
                                }}
                            />
                        )}
                        {popup_heading_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    popup_heading_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            popup_heading_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={popup_heading_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
        </div>
    );
};

export default DesignGeneralCard;
